import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

// Group your app and providers together to keep the code clean
const appComponent = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If react-snap has already generated HTML inside the root div, we hydrate it.
// If the root div is empty (like during local development), we render normally.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, appComponent);
} else {
  const root = createRoot(rootElement);
  root.render(appComponent);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();